import { render } from "./BuyRequestsBoard.vue?vue&type=template&id=02532516&scoped=true"
import script from "./BuyRequestsBoard.vue?vue&type=script&lang=js"
export * from "./BuyRequestsBoard.vue?vue&type=script&lang=js"

import "./BuyRequestsBoard.vue?vue&type=style&index=0&id=02532516&lang=css"
import "./BuyRequestsBoard.vue?vue&type=style&index=1&id=02532516&lang=css"
import "./BuyRequestsBoard.vue?vue&type=style&index=2&id=02532516&lang=css"
import "./BuyRequestsBoard.vue?vue&type=style&index=3&id=02532516&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02532516"]])

export default __exports__